import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';

export const getLinkStyle = (): FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
  color: ${({ theme }) => theme.color.semantic.link.default};
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.color.semantic.link.default};
  transition: text-decoration-color 0.4s ease;

  // NOTE: Outline is used for the focus state (must be transparent for proper transition)
  outline-color: transparent;
  transition: outline-color 0.4s ease;

  :hover {
    color: ${({ theme }) => theme.color.semantic.link.hover};
  }

  :active {
    color: ${({ theme }) => theme.color.semantic.link.pressed};
  }
`;
